import axios from 'axios'

const auth = {
    async login(email, password) {
        const user = await axios.post('auth/login', {
            email: email,
            password: password,
        })
        console.log('user', user)
        return user
    },

    async changePassword(model) {
        return await axios.put(`auth/change_password`, model)
    },

    async requestPasswordReset(email) {
        return await axios.post(`auth/pre_forgot`, {
            email,
        })
    },

    async resetPassword(model) {
        return await axios.put(`auth/post_forgot`, model)
    },

    async getOrderData({ order_id, hash, timestamp }) {
        return await axios.get(
            `auth/get_order_data/?order_id=${order_id}&hash=${hash}&timestamp=${timestamp}`
        )
    },
    async postOrderCompleted(data) {
        console.log('posting data', data)
        return await axios.post(`auth/post_complete/`, data)
    },
}

export default auth
